<script lang="ts" setup>
const { width = '1em', strokeClass = undefined } = defineProps<{
  width?: string
  strokeClass?: string | Record<string, unknown> | Array<Record<string, unknown>>
}>()
</script>

<template>
  <div
    :style="{ width }"
    class="v-loader relative mx-auto"
    data-test="loader"
  >
    <svg
      class="v-loader__circle absolute bottom-0 left-0 right-0 top-0 m-auto h-full w-full origin-center"
      viewBox="25 25 50 50"
      data-test="loader-svg"
    >
      <circle
        :class="strokeClass ?? 'stroke-general-primary'"
        class="v-loader__path"
        cx="50"
        cy="50"
        fill="none"
        r="20"
        stroke-miterlimit="10"
        stroke-width="4"
        data-test="loader-circle"
      />
    </svg>
  </div>
</template>

<style scoped>
.v-loader:before {
  content: '';
  display: block;
  padding-top: 100%;
}

.v-loader__circle {
  will-change: transform;
  animation: rotate 2s linear infinite;
}

.v-loader__path {
  stroke-dasharray: 2, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>
